/* eslint-disable jsx-quotes */
import React, { useEffect, useRef, useState } from 'react';
import MetaSeo from '../MetaSeo';
import Slider from 'react-slick';
import axios from 'axios';
import { Form } from 'antd';
import { chunk } from 'lodash';
import { useRouter } from 'next/router';
import useTrans from '@/hooks/useTrans';
import BreadcrumbComponent from '../Other/BreadCrumbComponent';
import TextFooter from '../TextFooter';
import FAQ from '../Faq';
import styles from './franchise.module.css';

const Franchise = ({ listData, seo }) => {
  const {title_seo, description, text_footer} = seo || {};
  const trans = useTrans();
  const router = useRouter();
  const ref_form = React.useRef();

  const list_title_a = [
    {
      title: trans.franchise.faq_list_a_title_a,
      desc: 'franchise.faq_list_a_title_des_a',
    },
    {
      title: trans.franchise.faq_list_a_title_b,
      desc: 'franchise.faq_list_a_title_des_b',
    },
    {
      title: trans.franchise.faq_list_a_title_c,
      desc: 'franchise.faq_list_a_title_des_c',
    },
    {
      title: trans.franchise.faq_list_a_title_d,
      desc: 'franchise.faq_list_a_title_des_d',
    },
    {
      title: trans.franchise.faq_list_a_title_e,
      desc: 'franchise.faq_list_a_title_des_e',
    },
    {
      title: trans.franchise.faq_list_a_title_f,
      desc: 'franchise.faq_list_a_title_des_f',
    },

    {
      title: trans.franchise.faq_list_a_title_g,
      desc: 'franchise.faq_list_a_title_des_g',
    },
    {
      title: trans.franchise.faq_list_a_title_h,
      desc: 'franchise.faq_list_a_title_des_h',
    },
  ];

  const list_title_b = [
    {
      title: trans.franchise.faq_list_b_title_a,
      desc: 'franchise.faq_list_b_title_des_a',
    },
    {
      title: trans.franchise.faq_list_b_title_b,
      desc: 'franchise.faq_list_b_title_des_b',
    },
    {
      title: trans.franchise.faq_list_b_title_c,
      desc: 'franchise.faq_list_b_title_des_c',
    },
    {
      title: trans.franchise.faq_list_b_title_d,
      desc: 'franchise.faq_list_b_title_des_d',
    },
    {
      title: trans.franchise.faq_list_b_title_e,
      desc: 'franchise.faq_list_b_title_des_e',
    },

    {
      title: trans.franchise.faq_list_b_title_f,
      desc: 'franchise.faq_list_b_title_des_f',
    },

    {
      title: trans.franchise.faq_list_b_title_g,
      desc: 'franchise.faq_list_b_title_des_g',
    },

    {
      title: trans.franchise.faq_list_b_title_h,
      desc: 'franchise.faq_list_b_title_des_h',
    },
  ];

  const [isShow, setIsShow] = useState(false);
  const [dataPc, setDataPc] = useState([]);
  const [dataMb, setDataMb] = useState([]);

  const [checkIdx, setCheckIdx] = useState(4);
  const slick_ref = useRef();
  const setting = {
    prevArrow: <></>,
    nextArrow: <></>,
    className: 'frs-slider-pc'
  };

  const setting_mb = {
    className: 'frs-slider-mb',
    prevArrow: <></>,
    nextArrow: <></>,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
  };

  useEffect(() => {
    const format = chunk(listData, 4);
    setDataPc(format);
    setDataMb(listData);
  }, [listData]);

  const support = [
    // {
    //   name: 'Ms. Hana Ngô',
    //   des: 'Nhà sáng lập & Tổng Giám đốc HanaGold',
    //   link: '',
    //   img: '/assets/img/franchise/avt_a.png',
    // },
    {
      name: trans.info.name_a,
      des: trans.franchise.sp_des_a,
      link: '',
      img: '/assets/img/franchise/avt_b.png',
    },
    // {
    //   name: 'Mr. John Bui',
    //   des: 'Giám đốc Công nghệ HanaGold',
    //   link: '',
    //   img: '/assets/img/franchise/avt_c.png',
    // },

    {
      name: trans.info.name_b,
      des: trans.franchise.sp_des_b,
      link: '',
      img: '/assets/img/franchise/avt_d.png',
    },
  ];

  const arr_list_title_faq = [
    trans.franchise.faq_list_a,
    trans.franchise.faq_list_b,
  ];

  const validateEmail = email => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const handleSubmit = async () => {
    await ref_form.current.validateFields();
    try {
      await axios.post(
        'https://api.sheetbest.com/sheets/352b1e47-e6a2-4468-b1c9-5e1e95225703',
        {
          ...ref_form.current.getFieldsValue(),
          type: 'Nhượng quyền'
        },
        {
          headers: {
            'X-Api-Key':
              'W8-mITlc$!WHDjZuQUnXEYkWx7iOqkqOxR9J5Y15v6XjDgRoRIt@!Z5_SMmc54Zr',
          },
        },
      );
      alert('Đăng ký thành công');
      ref_form.current.resetFields();
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const handleShowDetails = idx => {
    setCheckIdx(idx);
    setIsShow(!isShow);
  };

  const dataSeo = {
    title: title_seo || 'HanaGold - Nhượng Quyền Trực Tuyến',
    description: description || '',
    image: 'https://hanagold.vn/assets/img/franchise/fr_seo.png?t=1',
    url: 'https://hanagold.vn/nhuong-quyen-kinh-doanh-vang',
  };

  return (
    <>
      <MetaSeo {...dataSeo} />

      {isShow && (
        <div
          className={styles["fr_modal_details"]}
          onClick={() => {
            setIsShow(!isShow);
            setCheckIdx(4);
          }}
        >
          <div onClick={e => e.stopPropagation()}>
            <div className={styles["fr_modal_details_close"]}>
              <img
                src="/assets/img/certificate/close.svg"
                alt="image"
                className="lazyload"
                onClick={() => {
                  setIsShow(!isShow);
                  setCheckIdx(4);
                }}
              />
            </div>
            <div className={styles["fr_modal_details_img"]}>
              <img
                src={
                  checkIdx === 0
                    ? '/assets/img/franchise/avt_details_b.png'
                    : '/assets/img/franchise/avt_details_d.png'
                }
                alt="image"
                className="lazyload"
              />
            </div>

            <div className={styles["fr_modal_details_content"]}>
              <div className={styles["fr_modal_details_img_mb"]}>
                <img
                  src={
                    checkIdx === 0
                      ? '/assets/img/franchise/avt_details_b.png'
                      : '/assets/img/franchise/avt_details_d.png'
                  }
                  alt="image"
                  className="lazyload"
                />
              </div>

              {checkIdx === 0 && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: trans.info?.in_a,
                  }}
                ></div>
              )}

              {checkIdx === 1 && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: trans.info?.in_b,
                  }}
                ></div>
              )}
            </div>
          </div>
        </div>
      )}

      <div className={styles["fr_banner"]}>
        <div className={styles["fr_banner_container"]}>
          <div className={styles["fr_banner_content"]} data-aos="fade-down">
            <div className='aff_breadcrumb_component'>
              <BreadcrumbComponent title='Nhượng quyền trực tuyến' url='nhuong-quyen-kinh-doanh-vang'/>
            </div>
            <div>
              <h1>{trans?.franchise.title}</h1>
              <p
                dangerouslySetInnerHTML={{
                  __html: trans?.franchise.title_text,
                }}
              ></p>
              <a
                href="https://drive.google.com/file/d/1lQ_jfvbp9jvmGSKGDRqF0-VZNVzoIbQ0/view"
                target="_blank"
              >
                {trans?.franchise.btn_a}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles["fr_list"]}>
        <div className={styles["fr_list_container"]}>
          <div className={styles["fr_list_content"]}>
            <div className={styles["fr_box"]}>
              <div data-aos="fade-down" data-aos-delay="150">
                <img
                  src="/assets/img/franchise/icon_a.svg"
                  alt="image"
                  className="lazyload"
                />
                <p>{trans?.franchise.fr_l_a}</p>
              </div>

              <div data-aos="fade-down" data-aos-delay="250">
                <img
                  src="/assets/img/franchise/icon_b.svg"
                  alt="image"
                  className="lazyload"
                />
                <p>{trans?.franchise.fr_l_b}</p>
              </div>

              <div data-aos="fade-down" data-aos-delay="350">
                <img
                  src="/assets/img/franchise/icon_c.svg"
                  alt="image"
                  className="lazyload"
                />
                <p>{trans?.franchise.fr_l_c}</p>
              </div>
            </div>
            {listData?.length > 0 ? (
              <div className={styles["fr_list_title"]}>
                <h2>Danh Sách Đối Tác</h2>
                <h3>Nhượng Quyền Trực Tuyến</h3>
              </div>
            ) : null}
            {listData?.length > 0 ? (
              <>
                <div
                  className={`${styles["fr_list_slides"]} ${styles["fr_list_slides_dt"]}`}
                  data-aos="fade-down"
                >
                  <Slider {...setting} ref={slick_ref}>
                    {dataPc?.map((value, idx) => {
                      return (
                        <div key={idx}>
                          <div className={styles["list_f_adas"]}>
                            {value?.map((data, i) => {
                              return (
                                <div
                                  className={styles["fr_item_card"]}
                                  key={i}
                                  onClick={() => {
                                    router.push(`/nhuong-quyen-kinh-doanh-vang/${data.slug}`);
                                  }}
                                >
                                  <img
                                    src={data?.avatar}
                                    alt="image"
                                    className="lazyload"
                                  />
                                  <div className={styles["fr_hover"]}>
                                    <a>
                                      <img
                                        src="/assets/img/franchise/arrow.svg"
                                        alt="image"
                                        className="lazyload"
                                      />
                                      <p>Xem thêm</p>
                                    </a>
                                  </div>
                                  <div></div>
                                  <div className={styles["fr_item_text"]}>
                                    <div>
                                      <h2>{data?.name}</h2>
                                      <div>
                                        {data?.link_facebook && (
                                          <a
                                            onClick={e => {
                                              e.stopPropagation();
                                            }}
                                            href={data?.link_facebook}
                                            target="_blank"
                                          >
                                            <img
                                              src="/assets/img/franchise/lg_f.svg"
                                              alt="image"
                                              className="lazyload"
                                            />
                                          </a>
                                        )}
                                        {data?.link_zalo && (
                                          <a
                                            href={data?.link_zalo}
                                            target="_blank"
                                            onClick={e => {
                                              e.stopPropagation();
                                            }}
                                          >
                                            <img
                                              src="/assets/img/franchise/lg_z.svg"
                                              alt="image"
                                              className="lazyload"
                                            />
                                          </a>
                                        )}
                                      </div>
                                    </div>
                                    {data?.status ? (
                                      <div className={styles["is_partner_gold"]}>
                                        <img
                                          src="/assets/img/franchise/three_star.svg"
                                          alt="image"
                                        />

                                        <p>ĐỐI TÁC NHẬN VÀNG</p>
                                      </div>
                                    ) : (
                                      <div className={styles["is_partner_gold"]}></div>
                                    )}
                                    <div>
                                      <span>Email</span>
                                      <p>{data?.email}</p>
                                    </div>

                                    <div>
                                      <span>Địa chỉ</span>
                                      <p>{data?.address}</p>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>

                <div className={styles["fr_list_slides_mb"]} data-aos="fade-down">
                  <div className={styles["fr_list_card_mb"]}>
                    <Slider {...setting_mb}>
                      {dataMb?.map((value, idx) => {
                        return (
                          <div
                            className={styles["fr_card_mb"]}
                            key={idx}
                            onClick={() => {
                              router.push(`/nhuong-quyen-kinh-doanh-vang/${value.slug}`);
                            }}
                          >
                            <div className={`${styles["fr_card_img_mb"]} fr_card_img_mb1`}>
                              <img
                                src={value?.avatar}
                                alt="image"
                                className="lazyload"
                              />
                              <p>{value?.name}</p>
                            </div>
                            <div className={styles["fr_card_d_mb"]}>
                              {value?.status ? (
                                <div className={styles["is_partner_gold"]}>
                                  <img
                                    src="/assets/img/franchise/three_star.svg"
                                    alt="image"
                                  />

                                  <p>ĐỐI TÁC NHẬN VÀNG</p>
                                </div>
                              ) : null}
                              <div>
                                <span>Email</span>
                                <p>{value?.email}</p>
                              </div>
                              <div>
                                <span>Địa chỉ</span>
                                <p>{value?.address}</p>
                              </div>

                              <div>
                                <span>Kết nối</span>
                                <div>
                                  <div>
                                    <img
                                      onClick={e => {
                                        e.stopPropagation();
                                        window.open(value?.link_facebook);
                                      }}
                                      src="/assets/img/franchise/lg_z.svg"
                                      alt="image"
                                      className="lazyload"
                                    />
                                    <img
                                      onClick={e => {
                                        e.stopPropagation();
                                        window.open(value?.link_zalo);
                                      }}
                                      src="/assets/img/franchise/lg_f.svg"
                                      alt="image"
                                      className="lazyload"
                                    />
                                  </div>
                                  <a>Xem thêm</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </div>

                {dataPc?.length > 1 && (
                  <div className={styles["fr_control"]}>
                    <img
                      src="/assets/img/franchise/l.svg"
                      alt="image"
                      className="lazyload"
                      onClick={() => {
                        slick_ref?.current?.slickPrev();
                      }}
                    />
                    <img
                      src="/assets/img/franchise/r.svg"
                      alt="image"
                      className="lazyload"
                      onClick={() => {
                        slick_ref?.current?.slickNext();
                      }}
                    />
                  </div>
                )}
              </>
            ) : null}
          </div>
        </div>
      </div>
      {/* ) : null} */}

      <div className={styles["fe_benefit"]}>
        <div className={styles["fe_benefit_container"]}>
          <div className={styles["fe_benefit_content"]}>
            <div className={styles["fe_benefit_title"]}>
              <h2 dangerouslySetInnerHTML={{ __html: trans.franchise.be }}></h2>
            </div>
            <div className={styles["fe_benefit_items"]}>
              <div
                className={styles["fe_benefit_item"]}
                data-aos="fade-down"
                data-aos-delay="50"
                dangerouslySetInnerHTML={{ __html: trans.franchise.be_a }}
              ></div>

              <div
                className={styles["fe_benefit_item"]}
                data-aos="fade-down"
                data-aos-delay="100"
                dangerouslySetInnerHTML={{ __html: trans.franchise.be_b }}
              ></div>

              <div
                className={styles["fe_benefit_item"]}
                data-aos="fade-down"
                data-aos-delay="150"
                dangerouslySetInnerHTML={{ __html: trans.franchise.be_c }}
              ></div>

              <div
                className={styles["fe_benefit_item"]}
                data-aos="fade-down"
                data-aos-delay="200"
                dangerouslySetInnerHTML={{ __html: trans.franchise.be_d }}
              ></div>

              <div
                className={styles["fe_benefit_item"]}
                data-aos="fade-down"
                data-aos-delay="250"
                dangerouslySetInnerHTML={{ __html: trans.franchise.be_e }}
              ></div>

              <div
                className={styles["fe_benefit_item"]}
                data-aos="fade-down"
                data-aos-delay="300"
                dangerouslySetInnerHTML={{ __html: trans.franchise.be_f }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["fr_rank"]}>
        <div className={styles["fr_rank_container"]}>
          <div className={styles["fr_rank_content"]}>
            <div className={styles["fe_benefit_title"]} data-aos="fade-down">
              <h2
                dangerouslySetInnerHTML={{ __html: trans.franchise.title_se }}
              ></h2>
            </div>

            <div className={styles["fr_rank_table"]} data-aos="fade-down">
              <div className={styles["fr_rank_table_header"]}>
                <p className={styles["w-10"]}>{trans.franchise.table_a_title_a}</p>
                <p className={styles["w-60"]}>{trans.franchise.table_a_title_b}</p>
                <p className={styles["w-30"]}>{trans.franchise.table_a_title_c}</p>
              </div>

              <div className={styles["fr_rank_table_body"]}>
                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>1</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.rank_a}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>30.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>2</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.rank_b}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}></li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>3</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.rank_c}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}></li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>4</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.rank_d}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}></li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>5</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.rank_e}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}></li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>6</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.rank_f}</li>
                  <li className={`${styles["w-30"]} ${styles["text_yellow"]}`}>{trans.franchise.rank_g}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["fr_donate"]}>
        <div className={`${styles["fr_rank_container"]} ${styles["fr_donate_container"]}`}>
          <div className={styles["fr_rank_content"]}>
            <div className={styles["fe_benefit_title"]} data-aos="fade-down">
              <h2
                dangerouslySetInnerHTML={{ __html: trans.franchise.title_sp }}
              ></h2>
            </div>

            <div className={styles["fr_rank_table"]} data-aos="fade-down">
              <div className={styles["fr_rank_table_header"]}>
                <p className={styles["w-10"]}>{trans.franchise.table_a_title_a}</p>
                <p className={styles["w-60"]}>{trans.franchise.table_b_title_b}</p>
                <p className={styles["w-30"]}>{trans.franchise.table_b_title_c}</p>
              </div>

              <div className={styles["fr_rank_table_body"]}>
                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>1</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.sp_a}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>10.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>2</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.sp_b}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>45.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>3</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.sp_c}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>30.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>4</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.sp_d}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>50.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>5</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.sp_e}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>80.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>6</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.sp_f}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>80.000.000 VND</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["fr_donate"]}>
        <div className={`${styles["fr_rank_container"]} ${styles["fr_donate_container"]}`}>
          <div className={styles["fr_rank_content"]}>
            <div className={styles["fe_benefit_title"]} data-aos="fade-down">
              <h2
                dangerouslySetInnerHTML={{ __html: trans.franchise.title_ex }}
              ></h2>
            </div>

            <div className={styles["fr_rank_table"]} data-aos="fade-down">
              <div className={styles["fr_rank_table_header"]}>
                <p className={styles["w-10"]}>{trans.franchise.table_a_title_a}</p>
                <p className={styles["w-60"]}>{trans.franchise.table_b_title_b}</p>
                <p className={styles["w-30"]}>{trans.franchise.table_b_title_c}</p>
              </div>

              <div className={styles["fr_rank_table_body"]}>
                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>1</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.ex_a}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>30.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>2</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.ex_b}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>10.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>3</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.ex_c}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>45.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>4</li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.ex_d}</li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>30.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}>5</li>
                  <li
                    className={`${styles["w-60"]} ${styles["text_gray_b_i"]}`}
                    dangerouslySetInnerHTML={{ __html: trans.franchise.ex_e }}
                  ></li>
                  <li className={`${styles["w-30"]} ${styles["text_white_b"]}`}>50.000.000 VND</li>
                </ul>

                <ul className={styles["border_gray"]}>
                  <li className={`${styles["w-10"]} ${styles["text_gray_b"]}`}></li>
                  <li className={`${styles["w-60"]} ${styles["text_gray_b"]}`}>{trans.franchise.ex_f}</li>
                  <li className={`${styles["w-30"]} ${styles["text_yellow"]}`}>165.000.000 VND</li>
                </ul>
              </div>
            </div>

            <div className={styles["fr_rank_f"]}>
              <p
                dangerouslySetInnerHTML={{ __html: trans.franchise.text_des }}
              ></p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["fr_support"]}>
        <div className={styles["fr_support_container"]}>
          <div className={styles["fr_support_content"]}>
            <h2>{trans.franchise.sp_title}</h2>

            <div className={`${styles["fr_support_items"]} ${styles["fr_support_items_dt"]}`}>
              <div>
                {support?.map((data, idx) => {
                  return (
                    <div
                      className={styles["fr_support_item"]}
                      key={idx}
                      onClick={() => handleShowDetails(idx)}
                      data-aos="fade-down"
                      data-aos-delay={`${(idx + 1) * 100}`}
                    >
                      <img src={data?.img} alt="image" className="lazyload" />

                      <div className={styles["fr_support_bg"]}>
                        <p>{trans.franchise.read_more}</p>
                        <img src="/assets/img/franchise/ar_r.svg" alt="" />
                      </div>
                      <div></div>
                      <div className={styles["fr_support_details"]}>
                        <h3>{data.name}</h3>

                        {idx === 0 ? (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: trans.franchise.sp_des_a,
                            }}
                          ></p>
                        ) : (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: trans.franchise.sp_des_b,
                            }}
                          ></p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={`${styles["fr_support_items"]} ${styles["fr_support_items_mb"]}`}>
              <div>
                {support?.map((data, idx) => {
                  return (
                    <div
                      className={styles["fr_support_item_mb"]}
                      key={idx}
                      onClick={() => handleShowDetails(idx)}
                    >
                      <div className={styles["fr_support_item_mb_c"]}>
                        <div className={styles["fr_support_item_mb_c_l"]}>
                          <img
                            src={data?.img}
                            alt="image"
                            className="lazyload"
                          />
                        </div>
                        <div className={styles["fr_support_details_mb"]}>
                          <h3>{data.name}</h3>
                          <p
                            dangerouslySetInnerHTML={{ __html: data?.des }}
                          ></p>
                          <img
                            src="/assets/img/franchise/ar_r.svg"
                            alt="image"
                            className="lazyload"
                          />
                        </div>
                        <div></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["fr_step"]}>
        <div className={styles["fr_step_container"]}>
          <div className={styles["fr_step_content"]}>
            <h2 data-aos="fade-down">{trans.franchise.fr_step_title}</h2>
            <h3 data-aos="fade-down">{trans.franchise.fr_step_title_a}</h3>

            <div className={`${styles["fr_step_center"]} ${styles["fr_step_center_dt"]}`}>
              <div className={styles["fr_step_left"]}>
                <div data-aos="fade-down">
                  <div className={styles["fr_step_tt"]}>
                    <p>{trans.franchise.fr_step_a}</p>
                    <img
                      src="/assets/img/franchise/step_a.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                  </div>
                  <div className={styles["fr_bg_step"]}>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_a_des,
                      }}
                    ></p>
                  </div>
                </div>
                <div data-aos="fade-up">
                  <div className={styles["fr_step_tt"]}>
                    <p>{trans.franchise.fr_step_b}</p>
                    <img
                      src="/assets/img/franchise/step_b.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                  </div>
                  <div className={styles["fr_bg_step"]}>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_b_des,
                      }}
                    ></p>
                  </div>
                </div>
              </div>
              <div className={styles["fr_step_centered"]} data-aos="zoom-in">
                <img src="/assets/img/franchise/bg_centered.svg?t=1" alt="" />
                <p>{trans.franchise.fr_step_title_center}</p>
              </div>
              <div className={styles["fr_step_right"]}>
                <div data-aos="fade-down">
                  <div className={`${styles["fr_step_tt"]} ${styles["fr_step_tt_r"]}`}>
                    <img
                      src="/assets/img/franchise/step_c.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                    <p>{trans.franchise.fr_step_c} </p>
                  </div>
                  <div className={`${styles["fr_bg_step"]} ${styles["fr_bg_step_r"]}`}>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_c_des,
                      }}
                    ></p>
                  </div>
                </div>

                <div data-aos="fade-up">
                  <div className={`${styles["fr_step_tt"]} ${styles["fr_step_tt_r"]}`}>
                    <img
                      src="/assets/img/franchise/step_d.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                    <p>{trans.franchise.fr_step_d}</p>
                  </div>
                  <div className={`${styles["fr_bg_step"]} ${styles["fr_bg_step_r"]}`}>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_d_des,
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles["fr_step_center_mb"]}>
              <div className={styles["fr_step_center_mb_items"]}>
                <div className={styles["fr_step_center_mb_item"]}>
                  <div className={styles["fr_step_center_mb_item_pic"]}>
                    <img
                      src="/assets/img/franchise/step_a_mb.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                  </div>
                  <div className={styles["fr_step_center_mb_item_t"]}>
                    <h4 className={styles['step-title']}>{trans.franchise.fr_step_a}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_a_des,
                      }}
                    ></p>
                  </div>
                </div>

                <div className={styles["fr_step_center_mb_item"]}>
                  <div className={styles["fr_step_center_mb_item_pic"]}>
                    <img
                      src="/assets/img/franchise/step_b_mb.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                  </div>
                  <div className={styles["fr_step_center_mb_item_t"]}>
                    <h4 className={styles['step-title']}>{trans.franchise.fr_step_b}</h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_b_des,
                      }}
                    ></p>
                  </div>
                </div>

                <div className={styles["fr_step_center_mb_item"]}>
                  <div className={styles["fr_step_center_mb_item_pic"]}>
                    <img
                      src="/assets/img/franchise/step_c_mb.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                  </div>
                  <div className={styles["fr_step_center_mb_item_t"]}>
                    <h4 className={styles['step-title']}>{trans.franchise.fr_step_c} </h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_c_des,
                      }}
                    ></p>
                  </div>
                </div>

                <div className={styles["fr_step_center_mb_item"]}>
                  <div className={styles["fr_step_center_mb_item_pic"]}>
                    <img
                      src="/assets/img/franchise/step_d_mb.svg"
                      alt="iamge"
                      className="lazyload"
                    />
                  </div>
                  <div className={styles["fr_step_center_mb_item_t"]}>
                    <h4 className={styles['step-title']}>{trans.franchise.fr_step_b} </h4>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: trans.franchise.fr_step_d_des,
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FAQ 
        title={trans.franchise.faq}
        arr_list_title_faq={arr_list_title_faq}
        arr_detail_fag={[list_title_a, list_title_b]}
      />

      <div className="aff_sign_up" id="aff_sign_up">
        <div className={`${styles["fr_sign_u_p_container"]} aff_sign_u_p_container`}>
          <div
            className={`${styles["fr_sign_up_content"]} aff_sign_up_content`}
            data-aos="fade-down"
          >
            <div className={`${styles["fr_sign_up_title_mb"]} aff_sign_up_title`}>
              <h2>{trans.franchise.sign}</h2>
              <h3>{trans.franchise.sign_a}</h3>
            </div>
            <div className={`${styles["fr_sign_up_content_img"]} aff_sign_up_content_img`}>
            </div>

            <div className={`${styles["fr_sign_up_r"]} aff_sign_up_r`}>
              <div className={`${styles["fr_sign_up_title_dt"]} aff_sign_up_title`}>
                <h2>{trans.franchise.sign}</h2>
                <h3>{trans.franchise.sign_a}</h3>
              </div>
              <Form ref={ref_form}>
                <div className="c-modal-account__inner__form-login">
                  <div
                    className="c-modal-account__inner__form-login__form jhdggqgdas"
                    style={{ float: 'left' }}
                  >
                    <div className="c-modal-account__inner__form-login__form__input csss_bg_i">
                      <Form.Item
                        name="name"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value)
                                return Promise.reject(trans.message.val_m);
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          type="text"
                          placeholder={trans.message.pla_a}
                          autoComplete="off"
                        />
                      </Form.Item>
                    </div>
                    <div className="c-modal-account__inner__form-login__form__input mobile csss_bg_i">
                      <Form.Item
                        name="mail"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value)
                                return Promise.reject(trans.message.val_f);
                              if (!validateEmail(value))
                                return Promise.reject(trans.message.val_a);
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          type="text"
                          placeholder={trans.message.pla_d}
                          autoComplete="off"
                        />
                      </Form.Item>
                    </div>
                    <div className="c-modal-account__inner__form-login__form__input mobile csss_bg_i">
                      <Form.Item
                        name="mobile"
                        rules={[
                          {
                            validator: (_, value) => {
                              const regexPhone = /^(\+[0-9]{2})?[\d]+$/;
                              if (!value)
                                return Promise.reject(trans.message.val_c);
                              if (!regexPhone?.test(value) || value.length > 13)
                                return Promise.reject(
                                  'Sai định dạng số điện thoại!',
                                );

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <input
                          type="text"
                          placeholder={trans.message.pla_e}
                          autoComplete="off"
                        />
                      </Form.Item>
                    </div>
                    <div className="c-modal-account__inner__form-login__form__input mobile csss_bg_i">
                      <Form.Item name="job">
                        <input
                          type="text"
                          placeholder={trans.message.pla_t}
                          autoComplete="off"
                        />
                      </Form.Item>
                    </div>

                    <div
                      className="c-modal-account__inner__form-login__form__btn"
                      onClick={handleSubmit}
                    >
                      <a className="btn_sign">{trans.franchise.btn_b}</a>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <TextFooter text={text_footer}/>
    </>
  );
};

export default Franchise;
